import React from 'react';
import { useTranslation } from 'next-i18next';
import styles from '../negotiation-listings-card.module.scss';

const NegotiationListingsViewButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  const { t } = useTranslation('negotiation');

  return (
    <button
      className={`vc-text-H14 vc-link ${styles.negotiationListings__card__cta__link}`}
      onClick={onClick}
      data-cy="negotiation_pages_cta_view"
    >
      {t('NEGOTIATION_LISTING.OFFERS_SHARED.CTA.VIEW')}
    </button>
  );
};

export default NegotiationListingsViewButton;
